import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import { toToman } from "../../utils/Utils";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ReactComponent as CreditBoxIcon } from "../../assets/icons/credit-box.svg";
import moment from "moment-jalaali";

const ProfitItem = ({ title, value }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Typography mt="6px" variant="h6" color="grey.2">
        {value}
      </Typography>
    </Box>
  );
};

function LastProfitBanner({ sx = [], ...props }) {
  const { profit } = props;
  const [open, setOpen] = useState(false);
  return (
    <Box
      onClick={() => {
        setOpen((prev) => !prev);
      }}
      sx={{
        width: "100%",
        p: "16px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        {open ? (
          <KeyboardArrowUpIcon sx={{ color: "primary.main", height: 20 }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ color: "primary.main", height: 20 }} />
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <CreditBoxIcon width={24} height={24} />
        <Box
          sx={{
            ml: "12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="body2" color="secondary.main">
            آخرین سود واریزی
          </Typography>
          <Typography variant="subtitle1" color="grey.4">
            {profit.fundName}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mt: "16px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            minHeight: 60,
          }}
        >
          <Box sx={{ flex: 1, minHeight: "100%" }}>
            <ProfitItem
              title="سود کل"
              value={`${toToman(profit.totalProfit)} تومان`}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: "100%",
              borderLeft: (theme) => `1px solid ${theme.palette.grey[5]}`,
              borderRight: (theme) => `1px solid ${theme.palette.grey[5]}`,
            }}
          >
            <ProfitItem
              title="سود هر واحد"
              value={`${toToman(profit.profitPerUnit)} تومان`}
            />
          </Box>
          <Box sx={{ flex: 1, minHeight: "100%" }}>
            <ProfitItem title="تعداد واحد" value={profit.unit} />
          </Box>
        </Box>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          sx={{
            minHeight: 60,
            display: "flex",
            borderTop: (theme) => `1px solid ${theme.palette.grey[5]}`,
          }}
        >
          <Box sx={{ flex: 1, minHeight: "100%" }}>
            <ProfitItem
              title="تاریخ سررسید"
              value={moment(profit.date, "YYYY-MM-DD").format("jYYYY/jMM/jDD")}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: "100%",
              borderLeft: (theme) => `1px solid ${theme.palette.grey[5]}`,
              borderRight: (theme) => `1px solid ${theme.palette.grey[5]}`,
            }}
          >
            <ProfitItem title="واریز به" value={"حساب سجام"} />
          </Box>
          <Box sx={{ flex: 1, minHeight: "100%" }}>
            <ProfitItem title="نوع سود" value={"دوره‌ای"} />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

export default LastProfitBanner;
